import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { object_map } from "@pdfking/rfunc"
import { RecordMerge } from "@pdfking/tfunc"
import autocomplete from "../constants/autocomplete"
import { DoubleMixin } from "./Double"

export const DoubleAutocomplete = CreateRenderFunction({
  mixins: [DoubleMixin],
  computed: {
    options(): Record<string, Record<string, Record<string, string>>> {
      const content = autocomplete()[this.autocomplete]

      if (content) {
        return RecordMerge({}, this.extra || {}, {
          [content.title || ""]: object_map(
            (c: { name: string }) => c.name,
            (c: { objects: unknown }) => c.objects,
            content.objects
          ),
        })
      }
      return this.extra || {}
    },
  },
  props: {
    autocomplete: "",
    extra: null as Record<
      string,
      Record<string, Record<string, string>>
    > | null,
    manual_size: false,
  },
})
